import { createAction, props } from '@ngrx/store';
import {
  GBMConversationItemModel,
  GBMMessageItemModel,
} from '../../models/GBMessage.model';

export enum GbmActionTypes {
  getGbmConversationsBegin = '[Messages] Get Gbm Conversations Begin',
  getGbmConversationsSuccess = '[Messages] Get Gbm Conversations Success',
  getGbmConversationsFail = '[Messages] Get Gbm Conversations Fail',

  getGbmConversationMessagesBegin = '[Messages] Gbm Conversation Messages Begin',
  getGbmConversationMessagesSuccess = '[Messages] Gbm Conversation Messages Success',
  getGbmConversationMessagesFail = '[Messages] Gbm Conversation Messages Fail',

  replyGbmConversationMessageBegin = '[Messages] Reply Gbm Conversation Message Begin',
  replyGbmConversationMessageSuccess = '[Messages] Reply Gbm Conversation Message Success',
  replyGbmConversationMessageFail = '[Messages] Reply Gbm Conversation Message Fail',
}

// GET Conversations
export const getGbmConversationsBeginAction = createAction(
  GbmActionTypes.getGbmConversationsBegin,
  props<{ sorting?: 'ASC' | 'DESC' }>()
);
export const getGbmConversationsSuccessAction = createAction(
  GbmActionTypes.getGbmConversationsSuccess,
  props<{ payload: any[] }>()
);
export const getGbmConversationsFailAction = createAction(
  GbmActionTypes.getGbmConversationsFail,
  props<{ errors: any }>()
);

// GET Conversation messages
export const getGbmConversationMessagesBeginAction = createAction(
  GbmActionTypes.getGbmConversationMessagesBegin,
  props<{ payload: string | number }>()
);
export const getGbmConversationMessagesSuccessAction = createAction(
  GbmActionTypes.getGbmConversationMessagesSuccess,
  props<{ payload: GBMMessageItemModel[] }>()
);
export const getGbmConversationMessagesFailAction = createAction(
  GbmActionTypes.getGbmConversationMessagesFail,
  props<{ errors: any }>()
);

// REPLY Conversations
export const replyGbmConversationMessageBeginAction = createAction(
  GbmActionTypes.replyGbmConversationMessageBegin,
  props<{ conversationId: string | number; message: string }>()
);
export const replyGbmConversationMessageSuccessAction = createAction(
  GbmActionTypes.replyGbmConversationMessageSuccess,
  props<{ payload: any[] }>()
);
export const replyGbmConversationMessageFailAction = createAction(
  GbmActionTypes.replyGbmConversationMessageFail,
  props<{ errors: any }>()
);
